import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n-vue/index";
import VueAnimXYZ from "@animxyz/vue";
import ElementUI from "element-ui";
import "./common/app.css";
import "element-ui/lib/theme-chalk/index.css";
import "@/common";
import "@/directives";
// import '@/common/vant'
import Vant from "vant";
import "vant/lib/index.css";

import "@/mixin";
import "@animxyz/core"; // Import css here if you haven't elsewhere
import Storage from "vue-ls";
import TextHighlight from "vue-text-highlight";
Vue.component("text-highlight", TextHighlight);
const options = {
  namespace: "vue__", // 存储的key键前缀，可自定义
  name: "ls", // 命名Vue变量.ls则使用为this.$ls或者Vue.ls,
  storage: "local", // 存储名称: session, local, memory，更改为session则默认存储在sessionStorage
};

Vue.use(Storage, options); //使用vue-ls插件
Vue.use(Vant);
Vue.use(VueAnimXYZ);
Vue.use(ElementUI);
Vue.config.productionTip = false;
new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app");
